import { render, staticRenderFns } from "./ExamineEditComponent.vue?vue&type=template&id=66819fc6"
import script from "./ExamineEditComponent.vue?vue&type=script&lang=js"
export * from "./ExamineEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ExamineEditComponent.vue?vue&type=style&index=0&id=66819fc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports